import configs from './config';

const baseFormURL = configs.form_api_base_url;
const baseEzyFormsURL = configs.ezyForms_base_url;

const formUrls = {
  form: `${baseFormURL}/webForm/`,
  oldestEzyForms: `${baseEzyFormsURL}/external/form/oldest/`,
};

export default formUrls;
